module.exports = __webpack_public_path__ + "img/net-tahmin-appicon.d1b99230.png";